module.exports = __webpack_public_path__ + "img/29.50db8977.jpg";